import ApiRequest from "@/helpers/ApiRequest";
import GetHeaders from "@/helpers/GetHeaders";
import ParseUser from "@/helpers/ParseUser";
import { SAVE_USERS } from "@/store/mutation-types";

export default {
  actions: {
    updateUser: async ({ dispatch }, payload) => {
      return ApiRequest.explorePut(
        "user",payload,
        GetHeaders.projectHeaders()
      ).then(res => {
        dispatch("loadUsers");
        return res.data;
      });
    },
    loadUser: async (_, payload) => {
      return ApiRequest.exploreGet(
        "users/" + payload.id,
        GetHeaders.projectHeaders()
      ).then(res => {
        return ParseUser.parse(res.data);
      });
    },
    loadUsers: async ({ commit }) => {
      return ApiRequest.exploreGet("users", GetHeaders.projectHeaders()).then(
        res => {
          const mappedUsers = ParseUser.parseArray(res.data);
          commit(SAVE_USERS, { users: mappedUsers });
        }
      );
    }
  },
  getters: {
    userById: state => payload => state.users.find(u => u._id === payload.id)
  },
  mutations: {
    [SAVE_USERS](state, payload) {
      state.users = payload.users;
    }
  },
  state: {
    users: []
  }
};
